import { Button } from '@/components/ui/button'
import { useActiveOrg } from '@/hooks/use-active-org'
import { useUserPreference } from '@/hooks/use-user-preference'
import { cn } from '@/lib/utils'
import { CircleHelp } from 'lucide-react'

export const TourButton = ({
  onClick,
  variant,
}: {
  onClick: () => void
  variant?: 'outline' | 'ghost' | 'default' | 'secondary' | 'destructive' | 'link'
}) => {
  const { activeOrg } = useActiveOrg()
  const { userPreferences } = useUserPreference()

  const isHelpTourDisabled = userPreferences?.find((preference) => preference.key === 'help-tour')?.value === 'off'

  if (!activeOrg?.isOnboardingCompleted) return null
  if (isHelpTourDisabled) return null

  return (
    <Button
      size='icon'
      variant={variant || 'default'}
      onClick={onClick}
      className={cn('rounded-full absolute bottom-6 right-6 lg:flex hidden z-11')}
    >
      <CircleHelp />
    </Button>
  )
}
